import { getHttpApi } from '@cian/http-api/browser';
import {
  fetchGeocodeCached,
  IGeocodeCachedRequest,
  TGeocodeCachedResponse,
} from '../../repositories/geo/v1/geocode-cached';

export async function getCachedGeocode(parameters: IGeocodeCachedRequest) {
  try {
    const httpApi = getHttpApi();

    const { response, statusCode }: TGeocodeCachedResponse = await fetchGeocodeCached({
      httpApi,
      parameters,
    });

    if ('errors' in response || statusCode !== 200) {
      throw response;
    }

    return response;
  } catch (error) {
    throw error;
  }
}
